<template>
  <div class="box-container">
    <div
      class="box-item"
      v-for="item in classList"
      :key="item.id"
      @click="toDetail(item)">
      <img :src="item.pictureUrl" alt="" class="pic">
      <div class="text-wrapper">
        <p class="title" v-html="item.name"></p> 
        <div class="info-box">
          <div class="flex line1">
            <p><img src="../../../assets/class-icon/time-icon.png" alt="" class="icon"> 学时：{{ item.period }}学时</p>
            <p><img src="../../../assets/class-icon/class-icon.png" alt="" class="icon"> 包含课程：{{ item.courseNumber + item.trainNumber }}门（{{ item.courseNumber }}门课程/{{ item.trainNumber }}门实训）</p>
          </div>
          <p><img src="../../../assets/class-icon/open-time-icon.png" alt="" class="icon"> 开班时间：{{ item.openStartTime.split(' ')[0] }} 至 {{ item.openEndTime.split(' ')[0] }}</p>
          <p class="text"><img src="../../../assets/class-icon/address-icon.png" alt="" class="icon"> 培训地点：{{ item.address }}</p>
          <p class="text"><img src="../../../assets/class-icon/user-icon.png" alt="" class="icon"> 培训对象：{{ item.trainObject }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      classList: []
    }
  },
  watch: {
    list(val) {
      this.classList = val
    }
  },
  mounted() {
    this.classList = this.list
  },
  methods: {
    toDetail(data) {
      this.$router.push({
        path: '/classDetail',
        query: {
          id: data.id,
          name: this.$route.query.searchValue
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  .flex {
    display: flex;
    flex-direction: row;
  }
  .box-item {
    border-bottom: 1px dashed rgba(181, 181, 181, .35);
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    &:last-child {
      border-bottom: none;
    }
    .pic {
      width: 220px;
      height: 120px;
    }
    .icon {
      height: 11px;
    }
    .text-wrapper {
      margin-left: 29px;
      .title {
        color: #333;
        font-size: 18px;
        font-weight: bold;
        padding: 0;
      }
      .info-box {
        .line1 p{
          &:last-child {
            margin-left: 40px;
          }
        }
        p {
          color: #666;
          font-size: 14px;
          line-height: 24px;
        }
        .text {
          width: 800px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
